export const helloWorld = () => {
  alert("Hello from Illustrator");
  app.activeDocument.path;
};
